import { useParams } from "react-router-dom";
import NeuigkeitEditor from "../components/super-admin/neuigkeiten/NeuigkeitEditor";
import NeuigkeitenListe from "../components/super-admin/neuigkeiten/NeuigkeitenListe";
import SuperAdminSeite from "../components/super-admin/SuperAdminSeite";

/**
 * Die Neuigkeiten im Super-Admin (KAN-276).
 *
 * Mit Kennung in der Adresse steht die Schreibflaeche, ohne die Liste — dieselbe Seite,
 * zwei Zustaende. So bleibt der Zurueck-Weg im Browser der, den man erwartet.
 */
export const SuperAdminNeuigkeiten = () => {
  const { id } = useParams<{ id: string }>();

  return <SuperAdminSeite aktiv="neuigkeiten">{id ? <NeuigkeitEditor /> : <NeuigkeitenListe />}</SuperAdminSeite>;
};

export default SuperAdminNeuigkeiten;
